import React from "react";
import { ExclamationTriangleIcon, CheckCircleIcon, ClockIcon, PlusCircleIcon } from "@heroicons/react/24/outline"; // Example icons

const StatusCard = ({ label, date, hasIssue,delivered }) => {
  // Define static colors and icons for each label
  const styles = {
    Initiated: {
      borderColor: "#357F3F",
      textColor: "black",
      icon: <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.83334 13.6C8.25804 14.4031 8.97945 15.0676 9.88888 15.4934C10.7983 15.9191 11.8465 16.083 12.8755 15.9604C13.9045 15.8378 14.8586 15.4353 15.594 14.8136L17 13.7451M17 16V13.6H14.5M16.1667 10.4C15.742 9.59687 15.0206 8.93238 14.1111 8.50664C13.2017 8.08091 12.1535 7.91699 11.1245 8.03959C10.0955 8.16219 9.1414 8.56467 8.40599 9.18637L7 10.2549M7 8V10.4H9.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="black" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
      
      ,
    },
    Shipped: {
      borderColor: "#357F3F",
      textColor: "black",
      icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="0.6" stroke="currentColor" width="60" height="60">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
            </svg>
    ,
    },
    Issue: hasIssue
      ? {
          borderColor: "#FC4C02",
          textColor: "black",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="0.6"
              width="60"
              height="60"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>
          ),
        }
      : {
          borderColor: "#357F3F",
          textColor: "black",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="0.6"
              stroke="currentColor"
              width="60"
              height="60"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            
          ),
        },
        ETA: {
          borderColor: delivered ? "#357F3F" : "#9B9B9B", // Dynamic border color
          textColor: "black",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="0.6"
              stroke="currentColor"
              width="60"
              height="60"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          ),
        },
  };

  const style = styles[label] || {}; // Fallback to empty style if label is not found

  return (
    <div
      className={`flex items-center bg-bg gap-4 p-3 border-[3px] rounded-lg`}
      style={{ borderColor: style.borderColor }}
    >
      {/* Icon */}
      <div>{style.icon}</div>

      {/* Text Content */}
      <div>
        <p className="font-bold" style={{ color: style.textColor }}>
          {delivered && label === "ETA" ? "Delivered" : label}
        </p>
        {delivered ? (
          <p className="text-font-LIGHT">Arrived {date}</p>
        ) : (
          date && <p className="text-font-LIGHT">{date}</p>
        )}
        {label === "Issue" && !hasIssue && (
          <p className="text-font-LIGHT">All issues resolved</p>
        )}
        {label === "Issue" && hasIssue && (
          <p className="text-font-LIGHT">User Input Required</p>
        )}
      </div>
    </div>
  );
};

export default StatusCard;
